import { makeStyles, shorthands } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme";

export const useAppLeftBarSubMenuStyles = makeStyles({
    subMenuItem: {
        ...shorthands.padding("5px", "10px"),
        ...shorthands.border("none"),
        ":hover": {
            backgroundColor: themeTokens.colorSubtleBackgroundInvertedSelected
        }
    },
    selectedSubMenuItem: {
        backgroundColor: themeTokens.colorSubtleBackgroundInvertedSelected,
        fontWeight: "bold"
    },
    subMenu: {
        minWidth: "120px",
        textDecorationLine: "none"
    },
    link: {
        textDecorationLine: "none",
        color: themeTokens.colorNeutralForeground3
    }
});
